<template>
  <div class="index-page container">
    <n-card :loading="$var('load')" style="max-width: 1000px;">
      <h3 slot="header">Информация</h3>
      <n-form @submit="submit">
        <n-items style="margin-bottom: 10px;">
          <n-input v-bind="$form.input('username')" title="Логин" />
          <n-input v-bind="$form.input('fullName')" title="Имя" />
          <n-input v-bind="$form.input('password')" title="Пароль" />
          <n-button color="primary" type="submit">Сохранить</n-button>
        </n-items>
      </n-form>
    </n-card>
  
    <n-card :loading="$var('loadDelete')" style="max-width: 1000px;">
      <h3 slot="header">Удаление пользователя</h3>
      Осторожно! Операция необратима!
      <br />
      <n-button color="danger" style="margin-top: 10px; font-size: .7em" @click="deleteUser">Удалить пользователя</n-button>
    </n-card>
  </div>
</template>

<script>
export default {
  name: 'Index',
  data: () => ({
  }),
  computed: {
    userId() {
      return this.$route.params.id
    },
  },
  mounted() {
    this.loadYear()
  },
  methods: {
    loadYear() {
      this.$var('load', true)
      $api.app.users.get(this.userId).then((result) => {
        this.$form.init(result.data.content)
      }).finally(() => {
        this.$var('load', false)
      })
    },
    submit() {
      this.$var('load', true)
      $api.app.users.edit(this.userId, this.$form.get()).then((result) => {
        this.$form.init(result.data.content)
      }).finally(() => {
        this.$var('load', false)
      })
    },
    deleteUser() {
      this.$var('loadDelete', true)
      $api.app.users.delete(this.userId).then((response) => {
        this.$router.push({ name: 'users.list', })
      }).finally(() => {
        this.$var('loadDelete', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .index-page {
  
  }
</style>
